















import {Component, Prop, Vue} from "vue-property-decorator";
import AppConfig from "@/config/AppConfig";
import Comment from "@/views/Service/TimeTracking/TimeTable/Comment.vue";


@Component({
  components: {Comment},

})
export default class Comments extends Vue {
  public name: string = "Comments";

  @Prop({required: true})
  public comments!: Array<any>;

  private currentCommentIdx: number = 0;


}
